/*==========================
 訂單 相關功能Service

 Author : Alan
 最後更新時間 : 2016 / 02 / 26
==========================*/

window.InifECShared.factory("OrderService", ['$q', '$http', 'Upload', '$rootScope', function($q, $http, Upload, $rootScope) {

    var factory = {};
    var shipmentSearchUrlCache = {};
    var shippingTypeMap = {
        HCT: {
            type: 0,
            name: '新竹貨運',
        },
        // POST: { 暫時不提供
        //     type: 1,
        //     name: '郵局',
        // },
        MLE: {
            type: 2,
            name: '便利帶',
        },
    };

    // ------------------------------
    // 取得訂單列表
    // ------------------------------
    var getOrderList = function(start, len) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "getOrderList",
                start: start,
                len: len
            },
            withCredentials: true

        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.getOrderList request error.");
            console.error("status : " + status);
        });

        return defer.promise;

    }

    // ------------------------------
    // 取得訂單列表
    // ------------------------------
    var getOrderListWithStatus = function(orderstatus, start, len) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "getOrderListWithStatus",
                orderstatus: orderstatus,
                start: start,
                len: len
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.getOrderListWithStatus request error.");
            console.error("status : " + status);
        });

        return defer.promise;

    }

    // ------------------------------
    // 取得作廢的訂單列表
    // ------------------------------
    var getDiscardOrderList = function(start, len) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "getDiscardOrderList",
                start: start,
                len: len
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.getOrderListWithStatus request error.");
            console.error("status : " + status);
        });

        return defer.promise;

    }

    // ------------------------------
    // 取得特定範圍的訂單列表
    // ------------------------------
    var getOrderListWithStatusRange = function(startOrderstatus, endOrderstatus, start, len) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "getOrderListWithStatusRange",
                startOrderstatus: startOrderstatus,
                endOrderstatus: endOrderstatus,
                start: start,
                len: len
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.getOrderListWithStatus request error.");
            console.error("status : " + status);
        });

        return defer.promise;

    }

    // ------------------------------
    // 取得訂單詳細資訊
    // ------------------------------
    var getOrderInfo = function(orderid) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "getOrderDetail",
                orderid: orderid
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.getOrderListWithStatus request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 建立訂單(回傳字串)
    // ------------------------------
    var createOrder = function(delivery, senderInfo, addressInfo, isConfidentialDelivery, invoiceTitle, VATNumber, 
                                paymentmethod, orderitemids, remark, cartType, bonusPointsDiscount, isUseBonusPointsDiscount,
                                invoiceType, carrierType, loveCode, digitalCitizenCarrierID, 
                                mobilePhoneCarrierID, isDonate) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "createOrder",
                delivery: delivery,
                senderInfo: senderInfo,
                addressInfo: addressInfo,
                isConfidentialDelivery: isConfidentialDelivery,
                invoiceTitle: invoiceTitle,
                VATNumber: VATNumber,
                paymentmethod: paymentmethod,
                orderitemids: orderitemids,
                remark: remark,
                createfrommobile: window.isMobile || window.location.protocol == "file:",
                cartType: cartType,
                bonusPointsDiscount: bonusPointsDiscount,
                isUseBonusPointsDiscount: isUseBonusPointsDiscount,
                invoiceType: invoiceType,
                carrierType: carrierType,
                loveCode: loveCode,
                digitalCitizenCarrierID: digitalCitizenCarrierID,
                mobilePhoneCarrierID: mobilePhoneCarrierID,
                donate: isDonate,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.createOrder request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 建立訂單(回傳詳細資訊)
    // ------------------------------
    var createOrderWithFullReturn = function(delivery, senderInfo, addressInfo, 
        isConfidentialDelivery, invoiceTitle, VATNumber, 
        paymentmethod, orderitemids, remark, cartType, bonusPointsDiscount, isUseBonusPointsDiscount,
        invoiceType, carrierType, loveCode, digitalCitizenCarrierID, 
        mobilePhoneCarrierID, isDonate) {
            
        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "createOrderWithFullReturn",
                delivery: delivery,
                senderInfo: senderInfo,
                addressInfo: addressInfo,
                isConfidentialDelivery: isConfidentialDelivery,
                invoiceTitle: invoiceTitle,
                VATNumber: VATNumber,
                paymentmethod: paymentmethod,
                orderitemids: orderitemids,
                remark: remark,
                createfrommobile: window.isMobile || window.location.protocol == "file:",
                cartType: cartType,
                bonusPointsDiscount: bonusPointsDiscount,
                isUseBonusPointsDiscount: isUseBonusPointsDiscount,
                invoiceType: invoiceType,
                carrierType: carrierType,
                loveCode: loveCode,
                digitalCitizenCarrierID: digitalCitizenCarrierID,
                mobilePhoneCarrierID: mobilePhoneCarrierID,
                donate: isDonate,                
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.createOrderWithFullReturn request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 付款
    // ------------------------------
    var payForOrder = function(orderid, paymentmethod, totalamount) {

        var defer = $q.defer();
        var keynum = Math.floor((Math.random() * 3) + 1);

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "payForOrder",
                orderid: orderid,
                paymentmethod: paymentmethod,
                keynum:keynum
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
            	if (paymentmethod == Paytype_SinopacCreditCard) {
                    if(!data.logs || data.logs.length == 0) {
                        defer.reject(true);
                        return;
                    }

                    _payWithPaytype_SinopacCreditCard(orderid, paymentmethod, totalamount, data, keynum, defer);
                } else {
                    defer.resolve(data);
                }
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.identifyEmail payForOrder error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // [private] 信用卡付款（踢至銀行付款頁）
    // ------------------------------
    var _payWithPaytype_SinopacCreditCard = function(orderid, paymentmethod, totalamount, data, keynum, defer) {

        var gatewayRstJSON;
        var alllogs = data.logs;

        for(var i = 0; i < alllogs.length; i++){
            var logid = alllogs[i][0];
            if(logid.paytype == Paytype_SinopacCreditCard) {
                var log = alllogs[i][1]

                gatewayRstJSON = log.gatewayRstJSON;
                break;
            }
        }

        // app 付款
        if(window.location.protocol == "file:") {

            var form = {
                method: "POST",
                action: PAYMENT_URL,
                ShopNO: SINOPAC_ShopNO,
                KeyNum: keynum,
                OrderNO: orderid+'-'+paymentmethod+'-'+0,
                Amount: totalamount * 100,
                CurrencyID: "NTD",
                PrdtName: "inif印衣服",
                AutoBilling: "Y",
                Digest: gatewayRstJSON,
                Param1: "payFromApp", // 此flag讓永豐回傳可以踢到app要的回傳頁面
            }

            var msg = {
                type: 'payByCreditCard',
                form: form
            }

            msg = JSON.stringify(msg);

            // post msg to app
            if( window.WebViewBridge !== undefined && window.WebViewBridge.postMessage){
                window.WebViewBridge.postMessage(msg);
            } else if( window.WebViewBridge !== undefined && window.WebViewBridge.send){
                window.WebViewBridge.send(msg);
            }
        } else {
            var form = document.createElement("form");

            form.method = "POST";
            form.action = PAYMENT_URL;  

            var ShopNO = document.createElement("input"); 
            //ShopNO改取 SinopacContext.ShopNO 的值
            ShopNO.value= SINOPAC_ShopNO;
            ShopNO.name= "ShopNO";
            form.appendChild(ShopNO);  
            var KeyNum = document.createElement("input"); 
            //keyNum 直改random (1-3),與此次金鑰使用KeyNum 相同
            KeyNum.value= keynum;
            KeyNum.name= "KeyNum";
            form.appendChild(KeyNum);
            var OrderNO = document.createElement("input"); 
            OrderNO.value= orderid+'-'+paymentmethod+'-'+0;
            OrderNO.name= "OrderNO";
            form.appendChild(OrderNO);
            var Amount = document.createElement("input"); 
            // 金額要 *100 傳出
            Amount.value= totalamount * 100;
            Amount.name= "Amount";
            form.appendChild(Amount);
            var CurrencyID = document.createElement("input"); 
            CurrencyID.value= "NTD";
            CurrencyID.name= "CurrencyID";
            form.appendChild(CurrencyID);
            var PrdtName = document.createElement("input"); 
            PrdtName.value= "inif印衣服";
            PrdtName.name= "PrdtName";
            form.appendChild(PrdtName);
            var AutoBilling = document.createElement("input"); 
            AutoBilling.value= "Y";
            AutoBilling.name= "AutoBilling";
            form.appendChild(AutoBilling);
            var Digest = document.createElement("input"); 
            Digest.value= gatewayRstJSON;
            Digest.name= "Digest";
            form.appendChild(Digest);

            document.body.appendChild(form);
            form.submit();
        }

        defer.resolve(data);
    }

    // ------------------------------
    // 取得尚未付款訂單數量
    // ------------------------------
    var getOrderPayBadget = function() {

    	var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "getUnPayOrderBadget"
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                if(!window.isNaN(data)) {
                    factory.orderCount.orderPayBadget = data;
                } else {
                    factory.orderCount.orderPayBadget = 0;
                }
                defer.resolve(factory.orderCount.orderPayBadget);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.getOrderList request error.");
            console.error("status : " + status);
        });

        return defer.promise;

    }

    // ------------------------------
    // 上傳檔案
    // ------------------------------
    var uploadOrderItemFile = function(orderid, orderitemid, file) {

        var defer = $q.defer();

        // 超過單檔上限就不送（大檔還會被 nginx 413 擋下，而 413 不帶 CORS header，前端只看得到網路錯誤）
        if (!checkUploadFileSize(file)) {
            defer.reject({code: 'error.upload.fileTooLarge'});
            return defer.promise;
        }

        file.progress = 0;

        var fd = new FormData();

        fd.append('op', 'uploadOrderItemFile');
        fd.append('file', file);
        fd.append('orderid', orderid);
        fd.append('orderitemid', orderitemid);
        fd.append('filename', file.name);

        // 分流到 upload 子網域時，先確認登入等條件都正常才開始傳（見 global.js 的 precheckUploadServlet）
        var defaultUploadUrl = SECURE_INIFEC_URL + "/UploadServlet";
        var uploadUrl = getUploadServletUrl(defaultUploadUrl, file);

        precheckUploadServlet($http, $q, uploadUrl, defaultUploadUrl, 'uploadOrderItemFile').then(function() {

            Upload.http({
                url: uploadUrl, 
                data: fd,
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined},            
                withCredentials: true
            })
            // $http.post("/UploadServlet", fd, {
            //     transformRequest: angular.identity,
            //     headers: {'Content-Type': undefined}
            // })
            .progress(function(evt) {
                var percent = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = percent;
            })
            .success(function(data){
                if (data.error) {
                    defer.reject(data.error);
                } else {                                    
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : OrderService.uploadOrderItemFile error.");
                console.error("status : " + status);
            });

        }, function(error) {
            defer.reject(error);
            console.error("[InifEC Error] : 大檔上傳前的檢查失敗", error);
        });

        return defer.promise;
    }

    // ------------------------------
    // 從訂單歷史紀錄複製檔案
    // ------------------------------
    var uploadOrderItemFileByHistory = function(orderid, orderitemid) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "uploadFileByHistory",
                orderid: orderid,
                orderitemid: orderitemid
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.uploadOrderItemFileByHistory error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 作廢訂單
    // ------------------------------
    var discardOrder = function(orderid) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "discardOrder",
                orderid: orderid
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.uploadOrderItemFileByHistory error.");
            console.error("status : " + status);
        });

        return defer.promise;

    }


    // ------------------------------
    // 設定付款類型
    // ------------------------------
    var setPayType = function(orderid, paytype) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "setPayType",
                orderid: orderid,
                paymentmethod: paytype
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.getOrderListWithStatus request error.");
            console.error("status : " + status);
        });

        return defer.promise;

    }


    // ------------------------------
    // 申請退款
    // ------------------------------
    var refundOrder = function(orderid, refundIssue, file) {

        var defer = $q.defer();

        if(file){
            Upload.upload({
                url: '/OrderAction.do',
                fields: {
                    op: "refundOrder",
                    orderid: orderid,
                    refundIssue: refundIssue
                },
                file: file, // file: file,
                fileFormDataName: 'file',
                withCredentials: true
            }).progress(function(evt) {
                var percent = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = percent;
            }).success(function(data, status, headers, config) {
                if (data.error) {

                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }

                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : OrderService.getOrderListWithStatus request error.");
                console.error("status : " + status);
            });
        } else {
            $http({
                url: SECURE_INIFEC_URL + "/OrderAction.do",
                method: "GET",
                params: {
                    op: "refundOrder",
                    orderid: orderid,
                    refundIssue: refundIssue,
                    withCredentials: true
                }
            }).success(function(data) {
                if (data.error) {

                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }

                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : OrderService.getOrderListWithStatus request error.");
                console.error("status : " + status);
            });
        }
        
        return defer.promise;
    }

    // ------------------------------
    // 預儲點數付款
    // ------------------------------
    var payPointsForOrder = function(orderid){
        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "payPointsForOrder",
                orderid: orderid,
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.payPointsForOrder request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    };

    // ------------------------------
    // 月結點數付款
    // ------------------------------
    var payMonthlyForOrder = function(orderid){
        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "payMonthlyForOrder",
                orderid: orderid,
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.payMonthlyForOrder request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    };

    // ------------------------------
    // 使用url上傳稿件
    // ------------------------------
    var uplaodOrderFileByUrl = function(orderid, orderitemid, userfileurl) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "uplaodOrderFileByUrl",
                orderid: orderid,
                orderitemid: orderitemid,
                userfileurl: userfileurl
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.uplaodOrderFileByUrl error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 實體帳戶付款
    // ------------------------------
    var payOutwardRemittanceForOrder = function(orderid, remittanceName, remittanceCode, remittancePhone, remittanceDate){
        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "payOutwardRemittanceForOrder",
                orderid: orderid,
                remittanceName: remittanceName,
                remittanceCode: remittanceCode,
                remittancePhone: remittancePhone,
                remittanceDate: remittanceDate,
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.payOutwardRemittanceForOrder request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    };


    // ------------------------------
    // 取得尚未付補收款的訂單列表
    // ------------------------------
    var getExtraFeeUnpayOrderList = function(start, len) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "getExtraFeeUnpayOrderList",
                start: start,
                len: len
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.getExtraFeeUnpayOrderList request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 確認稿件完成，準備送印
    // ------------------------------
    var checkOrderReview = function(orderid) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "checkOrderReview",
                orderid: orderid,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.checkOrderReview error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 取得會員可以付款但是尚未付款的列表
    // ------------------------------
    var getUnPayOrderList = function(start, len) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "getUnPayOrderList",
                start: start,
                len: len,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.getUnPayOrderList error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 付款前的最後確認（可更改運送方式、發票以及紅利折抵）
    // ------------------------------
    var confirmOrderBeforePayment = function(orderid, delivery, addressInfo, senderInfo, isConfidentialDelivery, invoiceTitle, VATNumber, bonusPointsDiscount, isUseBonusPointsDiscount, invoiceType, carrierType, loveCode, digitalCitizenCarrierID, 
    mobilePhoneCarrierID, isDonate) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "confirmOrderBeforePayment",
                orderid: orderid,
                delivery: delivery,
                addressInfo: addressInfo,
                senderInfo: senderInfo,
                isConfidentialDelivery: isConfidentialDelivery,
                invoiceTitle: invoiceTitle,
                VATNumber: VATNumber,
                bonusPointsDiscount: bonusPointsDiscount,
                isUseBonusPointsDiscount: isUseBonusPointsDiscount,
                invoiceType: invoiceType,
                carrierType: carrierType,
                loveCode: loveCode,
                digitalCitizenCarrierID: digitalCitizenCarrierID,
                mobilePhoneCarrierID: mobilePhoneCarrierID,
                donate: isDonate,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.confirmOrderBeforePayment request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 取得特定範圍的訂單列表
    // ------------------------------
    var getOrderDelayAnnouncement = function() {

        if(factory.cache["getOrderDelayAnnouncement"]) {
            return factory.cache["getOrderDelayAnnouncement"].promise;
        }

        factory.cache["getOrderDelayAnnouncement"] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "GET",
            params: {
                op: "getOrderDelayAnnouncement",
            },
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.cache["getOrderDelayAnnouncement"].reject(data.error);
            } else {
                factory.cache["getOrderDelayAnnouncement"].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.cache["getOrderDelayAnnouncement"].reject(data);
            console.error("[InifEC Error] : OrderService.getOrderDelayAnnouncement request error.");
            console.error("status : " + status);
        });

        return factory.cache["getOrderDelayAnnouncement"].promise;
    }

    // ------------------------------
    // 取得訂單物流查詢網址
    // ------------------------------
    var getOrderShipmentSearchUrl = function(orderid, shippingCompanyType) {

        var defer = $q.defer();

        if(shipmentSearchUrlCache[orderid]) {
            defer.resolve(shipmentSearchUrlCache[orderid]);
            return defer.promise;
        }

        if(shippingCompanyType === shippingTypeMap.MLE.type) {
            shipmentSearchUrlCache[orderid] = "http://www.25431010.tw/Search.php";
            defer.resolve(shipmentSearchUrlCache[orderid]);
            return defer.promise;
        }

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "getOrderShipmentSearchUrl",
                orderid: orderid,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                shipmentSearchUrlCache[orderid] = data;
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.getOrderShipmentSearchUrl error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 清除訂單數量
    // ------------------------------
    var cleanOrderCount = function() {

        factory.orderCount.orderPayBadget = 0;
    }

    // ------------------------------
    // 使用者第一次設定收件資訊 (報價單的設定)
    // ------------------------------
    var firstSetDeliveryInfo = function(orderid, delivery, addressInfo, senderInfo, isConfidentialDelivery) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/OrderAction.do",
            method: "POST",
            data: $.param({
                op: "firstSetDeliveryInfo",
                orderid: orderid,
                delivery: delivery,
                senderInfo: senderInfo,
                addressInfo: addressInfo,
                isConfidentialDelivery: isConfidentialDelivery,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {

                if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                    $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                }

                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : OrderService.firstSetDeliveryInfo error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    /*==========================
        Members
    ==========================*/
    factory.orderCount = {
        orderPayBadget: 0,
    };
    factory.cache = {};
    factory.shippingTypeMap = shippingTypeMap;

    /*==========================
        Methods
    ==========================*/
    /** 取得訂單列表 */
    factory.getOrderList = getOrderList;
    /** 取得訂單列表 */
    factory.getOrderListWithStatus = getOrderListWithStatus;
    /** 取得作廢的訂單列表 */
    factory.getDiscardOrderList = getDiscardOrderList;
    /** 取得特定範圍的訂單列表 */
    factory.getOrderListWithStatusRange = getOrderListWithStatusRange;
    /** 取得訂單詳細資料 */
    factory.getOrderInfo = getOrderInfo;
    /** 建立訂單 */
    factory.createOrder = createOrder;
    // 建立訂單(回傳詳細資訊)
    factory.createOrderWithFullReturn = createOrderWithFullReturn;
    /** 付款 */
	factory.payForOrder = payForOrder;
	/** 取得尚未付款訂單數量 */
	factory.getOrderPayBadget = getOrderPayBadget;
	/** 上傳檔案 */
	factory.uploadOrderItemFile = uploadOrderItemFile;
    /** 從訂單歷史紀錄複製檔案 */
    factory.uploadOrderItemFileByHistory = uploadOrderItemFileByHistory;
    /** 作廢訂單 */
    factory.discardOrder = discardOrder;
    /** 更改付款方式 */
    factory.setPayType = setPayType;
    /** 申請退款 */
    factory.refundOrder = refundOrder;
    // 預儲點數付款
    factory.payPointsForOrder = payPointsForOrder;
    // 月結點數付款
    factory.payMonthlyForOrder = payMonthlyForOrder;
    // 使用url上傳稿件
    factory.uplaodOrderFileByUrl = uplaodOrderFileByUrl;
    // 實體帳戶付款
    factory.payOutwardRemittanceForOrder = payOutwardRemittanceForOrder;
    // 取得尚未付補收款的訂單列表
    factory.getExtraFeeUnpayOrderList = getExtraFeeUnpayOrderList;
    // 確認稿件完成，準備送印
    factory.checkOrderReview = checkOrderReview;
    // 取得會員可以付款但是尚未付款的列表
    factory.getUnPayOrderList = getUnPayOrderList;
    // 清除訂單數量
    factory.cleanOrderCount = cleanOrderCount;
    // 付款前的最後確認（可更改運送方式、發票以及紅利折抵）
    factory.confirmOrderBeforePayment = confirmOrderBeforePayment;
    // 取得特定範圍的訂單列表
    factory.getOrderDelayAnnouncement = getOrderDelayAnnouncement;
    // 取得訂單物流查詢網址
    factory.getOrderShipmentSearchUrl = getOrderShipmentSearchUrl;
    // 使用者第一次設定收件資訊 (報價單的設定)
    factory.firstSetDeliveryInfo = firstSetDeliveryInfo;

    return factory;
}]);